var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrinter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3384",
    d: "M0-682.665H21v21H0Z",
    transform: "translate(0 682.665)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_43267",
    "data-name": "Group 43267",
    transform: "translate(-10456 -14670)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16062",
    "data-name": "Rectangle 16062",
    width: 24,
    height: 24,
    transform: "translate(10456 14670)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g3378",
    transform: "translate(10457.5 14671.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3380"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3382",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3388",
    transform: "translate(0.615 5.906)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3390",
    d: "M-507.88-310.155h1.189a2.461,2.461,0,0,0,2.461-2.461v-4.922A2.461,2.461,0,0,0-506.69-320h-14.848A2.461,2.461,0,0,0-524-317.538v4.922a2.461,2.461,0,0,0,2.461,2.461h1.189",
    transform: "translate(523.999 319.999)",
    fill: "none",
    stroke: "#1564e8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3392",
    transform: "translate(3.281 12.469)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3394",
    d: "M-454.895,0h-14.437",
    transform: "translate(469.332)",
    fill: "none",
    stroke: "#1564e8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3396",
    transform: "translate(4.266 12.469)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3398",
    d: "M-38.769-249.417h10.008a1.231,1.231,0,0,0,1.23-1.23v-6.686H-40v6.686A1.231,1.231,0,0,0-38.769-249.417Z",
    transform: "translate(40 257.333)",
    fill: "none",
    stroke: "#1564e8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3400",
    transform: "translate(8.859 15.094)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3402",
    d: "M-103.385,0h-3.281",
    transform: "translate(106.666)",
    fill: "none",
    stroke: "#1564e8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3404",
    transform: "translate(8.859 17.719)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3406",
    d: "M-103.385,0h-3.281",
    transform: "translate(106.666)",
    fill: "none",
    stroke: "#1564e8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3408",
    transform: "translate(3.281 8.531)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3410",
    d: "M-62.031,0H-64",
    transform: "translate(64)",
    fill: "none",
    stroke: "#1564e8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3412",
    transform: "translate(4.266 0.615)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3414",
    d: "M-77.539,0h7.547a2.461,2.461,0,0,1,2.461,2.461v2.83H-80V2.461A2.461,2.461,0,0,1-77.539,0Z",
    transform: "translate(80)",
    fill: "none",
    stroke: "#1564e8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinter);
export default __webpack_public_path__ + "static/media/printer.e7a4c5c5d33fdf5797f3c408d9ba3c26.svg";
export { ForwardRef as ReactComponent };